import { IDropdownOption } from '@/features/user-settings';

import { Grapes } from '../types/grape-types';
import { YeastBrands } from '../types/yeast-brands';

export const getYeastBrandsOptions = (): IDropdownOption[] => {
  return [
    { label: 'fermentations.yeastBrands.enartis', value: YeastBrands.Enartis },
    { label: 'fermentations.yeastBrands.eaton', value: YeastBrands.Eaton },
    { label: 'fermentations.yeastBrands.fermentis', value: YeastBrands.Fermentis },
    { label: 'fermentations.yeastBrands.lallemand', value: YeastBrands.Lallemand },
    { label: 'fermentations.yeastBrands.erbsloh', value: YeastBrands.Erbsloh },
    { label: 'fermentations.yeastBrands.oenobrands', value: YeastBrands.Oenobrands },
    { label: 'fermentations.yeastBrands.redStar', value: YeastBrands.RedStar },
    { label: 'fermentations.yeastBrands.siha', value: YeastBrands.Siha },
    { label: 'fermentations.yeastBrands.enoferm', value: YeastBrands.Enoferm },
    { label: 'fermentations.yeastBrands.ab', value: YeastBrands.ABBiotekMaury },
    { label: 'fermentations.yeastBrands.phibro', value: YeastBrands.Phibro },
    { label: 'fermentations.yeastBrands.other', value: YeastBrands.Other },
  ];
};

export const getGrapesOptions = (): IDropdownOption[] => {
  return [
    { label: 'fermentations.grapes.white', value: Grapes.White },
    { label: 'fermentations.grapes.red', value: Grapes.Red },
    { label: 'fermentations.grapes.rose', value: Grapes.Rose },
    { label: 'fermentations.grapes.sparkling', value: Grapes.Sparkling },
    { label: 'fermentations.grapes.blancDeNoir', value: Grapes.BlancDeNoir },
    { label: 'fermentations.grapes.other', value: Grapes.Other },
  ];
};
